import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {IUpdatePassword, passwordValidationSchema} from '../../core/interface'
import {useSelector} from 'react-redux'
import {ScrollTopComponent} from '../../../../../../template/_metronic/assets/ts/components'
import {RootState} from '../../../../../../redux/store'
import {useChangePasswordMutation} from '../../../../../../redux/api/services/profile'
import {InputPassword} from '../../../../auth/components/input/InputPassword'
import {CustomErrorAlert} from '../../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

export const UpdatePasswordCard = () => {
  const infoState = useSelector((state: RootState) => state.info)
  const [changePassword, {isSuccess, isError, error, isLoading, reset}] =
    useChangePasswordMutation()

  const [showPasswordForm, setShowPasswordForm] = useState<boolean>(false)

  const formik = useFormik<IUpdatePassword>({
    initialValues: {cPassword: '', password: '', confirmPassword: ''},
    validationSchema: passwordValidationSchema,
    onSubmit: (values) => {
      changePassword({
        info: infoState,
        requestContent: {
          password: values.cPassword,
          newPassword: values.confirmPassword,
        },
      })
    },
  })

  const resetForm = () => {
    reset()
    formik.resetForm()
  }

  useEffect(() => {
    if (!isSuccess) return
    ScrollTopComponent.goTop()
    setShowPasswordForm(false)
    resetForm()
  }, [isSuccess])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Método de inicio de sesión</h3>
        </div>
      </div>

      <div className='card-body border-top p-9'>
        <CustomErrorAlert error={error} show={isError} className='mx-5' close={reset} />
        <div className='d-flex flex-wrap align-items-center mb-10'>
          <div className={' ' + (showPasswordForm && 'd-none')}>
            <div className='fs-6 fw-bolder mb-1'>Contraseña</div>
            <div className='fw-bold text-gray-600'>************</div>
          </div>

          <div className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}>
            <form onSubmit={formik.handleSubmit} className='form' noValidate>
              <div className='row mb-1'>
                <div className='mb-3'>
                  <label className='form-label fw-bolder mb-3'>Contraseña actual</label>
                  <InputPassword {...formik.getFieldProps('cPassword')} className={''} />
                  {formik.touched.cPassword && formik.errors.cPassword && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.cPassword}</div>
                    </div>
                  )}
                </div>

                <div className='mb-3'>
                  <label className='form-label fw-bolder mb-3'>Nueva contraseña</label>
                  <InputPassword {...formik.getFieldProps('password')} className={''} />
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.password}</div>
                    </div>
                  )}
                </div>

                <div className='mb-3'>
                  <label className='form-label fw-bolder mb-3'>Confirmar nueva contraseña</label>
                  <InputPassword {...formik.getFieldProps('confirmPassword')} className={''} />
                  {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.confirmPassword}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='mb-5'>
                <p>Tu contraseña debe cumplir con:</p>
                <ul>
                  <li>Al menos 6 caracteres</li>
                  <li>Al menos 1 mayúscula</li>
                  <li>Al menos 1 número</li>
                  <li>Al menos 1 carácter especial (%&#,*!)</li>
                </ul>
              </div>

              <div className='d-flex'>
                <button type='submit' className='btn btn-primary me-2 px-6' disabled={isLoading}>
                  {!isLoading && 'Actualiza contraseña'}
                  {isLoading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Espere por favor...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <button
                  onClick={() => {
                    setShowPasswordForm(false)
                    resetForm()
                  }}
                  type='button'
                  className='btn btn-color-gray-400 btn-active-light-primary px-6'
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>

          <div className={'ms-auto ' + (showPasswordForm && 'd-none')}>
            <button
              onClick={() => {
                setShowPasswordForm(true)
              }}
              className='btn btn-light btn-active-light-primary'
            >
              Cambiar la contraseña
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
